import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesBlackwaterComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 387.76 488.65"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m151 91.05 7.7 4.4-30.9 53.4-7.7-4.4a3.87 3.87 0 0 1-1.4-5.2l27.1-46.9a4 4 0 0 1 5.2-1.3Z" />
        <path d="m129.6 155.65-12-6.9a8.67 8.67 0 0 1-4.1-5.4 8.93 8.93 0 0 1 .8-6.6l27.3-47.2a9.06 9.06 0 0 1 11.9-2.9l12 6.9Zm-6-14.9 2.3 1.3 25.9-44.7-2.4-1.3Zm-1.1-.7Zm26-44.7ZM216.5 241.95a26.09 26.09 0 0 1-12.2-2.8c-5.8-3-8.7-7.6-11-11.2s-3.8-6-7.5-7.5-6.4-.7-11 1c-4.9 1.8-10.9 4-19.2 1.7-7-1.9-10.6-5.6-13.8-9-2.6-2.7-4.7-4.9-8.8-6.2-7.1-2.3-15.6-.3-25.4 5.8l-5.3-8.5c12.4-7.7 23.8-10 33.8-6.8 6.4 2 9.8 5.6 12.9 8.8 2.7 2.8 4.9 5.1 9.3 6.3 5.2 1.5 8.9.1 13.1-1.4 4.8-1.7 10.7-3.9 18.2-.9 6.7 2.7 9.7 7.5 12.2 11.4 2 3.2 3.7 5.9 7.1 7.7 6.6 3.4 16.2 1.8 28.4-4.9l4.8 8.8c-9.6 5-18.1 7.7-25.6 7.7ZM267.2 200.25 379.3 5.95a1.65 1.65 0 0 1 2.5-.6 1.65 1.65 0 0 1 .6 2.5l-112.1 194.3a1.65 1.65 0 0 1-2.5.6 2 2 0 0 1-.6-2.5Z" />
        <path d="M268.8 208.15a7.32 7.32 0 0 1-4-1.3 7 7 0 0 1-2-8.9v-.1L375 3.45a6.64 6.64 0 0 1 4.5-3.3 6.32 6.32 0 0 1 5 1 7 7 0 0 1 3.1 4.4 6.4 6.4 0 0 1-1 5l-112 194.1a6.64 6.64 0 0 1-4.5 3.3 5.85 5.85 0 0 1-1.3.2Zm-2.8-8.5ZM383.7 8.35c-.1.1 0 .1 0 0ZM77.29 255l146.07-3.1.08 4L77.37 259zM58.39 291.26l146.17-3.21.09 4-146.17 3.21zM31.99 327.37l146.05-3.29.1 4-146.06 3.3zM16.85 363.6l146.05-3.3.09 4-146.05 3.3z" />
        <path d="m93.6 218.38 3.24-2.33 85.07 118.78-3.26 2.32zM73.9 254.27l3.26-2.32 85.08 118.89-3.25 2.33zM60.09 291.3l3.25-2.33 85 118.83-3.25 2.32z" />
        <path d="M118.1 488.65a47.8 47.8 0 1 1 47.8-47.8 47.8 47.8 0 0 1-47.8 47.8Zm0-85.6a37.8 37.8 0 1 0 37.8 37.8 37.9 37.9 0 0 0-37.8-37.8Z" />
        <path d="m39.07 327.27 3.25-2.33 56.42 79.04-3.26 2.32z" />
        <path d="m20.48 396.37 117.78-2.59.08 4-117.77 2.59z" />
        <path d="M292.5 141.15a8.67 8.67 0 0 0-4.1-5.4l-102.5-59.1h-.1a8.93 8.93 0 0 0-6.6-.8 8.67 8.67 0 0 0-5.4 4.1c-31.7 55.1-61.1 106-89.9 155.7l-.9 1.5c-.3.5-.7 1.1-1 1.7-32.3 55.9-57.2 99.1-80.9 140.2a8.93 8.93 0 0 0-.8 6.6 8.67 8.67 0 0 0 4.1 5.4l76.7 44.3a36.52 36.52 0 0 1 2.9-9.9l-73.6-42.6c23.5-40.6 48.3-83.6 80.3-139l.9-1.5c.3-.5.7-1.1 1-1.7 28.6-49.5 57.8-100.1 89.3-154.8l100.4 58-151.1 261.8a39.05 39.05 0 0 1 8.8 4.7l151.7-262.6a8.87 8.87 0 0 0 .8-6.6Z" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesBlackwaterComponent.displayName = 'IconAmenitiesBlackwater';

const IconAmenitiesBlackwater = React.memo(IconAmenitiesBlackwaterComponent);

export default IconAmenitiesBlackwater;
